// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import {
//     Mail,
//     Phone,
//     MapPin,
//     MessageCircle,
//     Twitter,
//     Linkedin,
//     Instagram,
//     Send,
//     CheckCircle,
//     Clock,
// } from "lucide-react";
// import BackToTop from "../../components/BackToTop/BackToTop";
// import Footer from "../../layouts/Footer";
// import Header from "../../layouts/Header";
// import HeroBg from "../../../src/images/hero-bg.png";
// import AuthPopup from "../../components/popup/AuthPopup";


// const Contact = () => {
//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         subject: "",
//         message: "",
//         priority: "normal"
//     });

//     const [formStatus, setFormStatus] = useState({
//         submitted: false,
//         success: false,
//         message: ""
//     });

//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [showAuth, setShowAuth] = useState(false);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setIsSubmitting(true);

//         // Simulate API call
//         setTimeout(() => {
//             setFormStatus({
//                 submitted: true,
//                 success: true,
//                 message: "Thank you for reaching out! Our team will get back to you within 24 hours."
//             });
//             setIsSubmitting(false);

//             // Reset form
//             setFormData({
//                 name: "",
//                 email: "",
//                 subject: "",
//                 message: "",
//                 priority: "normal"
//             });
//         }, 1500);
//     };

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);


//     return (
//         <div className="bg-gradient-to-b from-gray-50 to-white">
//             <BackToTop />

//             {/* ================= HEADER ================= */}
//             <Header loginClick={() => { setShowAuth(true) }} />


//             <div className="relative">

//                 <div className="absolute inset-0 w-full h-full">
//                     <img
//                         src={HeroBg}
//                         loading="lazy"
//                         sizes="(max-width: 1440px) 100vw, 1440px"
//                         alt="hero"
//                         className="w-full h-full object-cover"
//                     />
//                 </div>

//                 {/* <div className="absolute inset-0 overflow-hidden">
//                     <div className="absolute top-0 -left-40 w-[400px] h-[400px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>
//                     <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-pink-200/20 via-purple-200/20 to-indigo-200/20 rounded-full blur-3xl animate-float-slower"></div>

//                     {[...Array(50)].map((_, i) => (
//                         <div
//                             key={i}
//                             className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
//                             style={{
//                                 left: `${Math.random() * 100}%`,
//                                 top: `${Math.random() * 100}%`,
//                                 animationDelay: `${Math.random() * 8}s`,
//                                 animationDuration: `${15 + Math.random() * 15}s`,
//                                 opacity: 0.2,
//                             }}
//                         />
//                     ))}
//                 </div> */}

//                 {/* Main Content */}
//                 <div className="max-w-7xl mx-auto px-6 py-20 relative">
//                     {/* Hero Section */}
//                     <div className="text-center my-12">
//                         <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6">
//                             <MessageCircle className="h-4 w-4 text-indigo-600" />
//                             <span className="text-sm font-medium text-indigo-600">Get in Touch</span>
//                         </div>
//                         <h1 className="text-4xl md:text-5xl font-bold mb-4">
//                             Contact{" "}
//                             <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
//                                 Us
//                             </span>
//                         </h1>
//                         <p className="text-xl text-gray-500 max-w-2xl mx-auto">
//                             Have questions? We're here to help. Reach out to our team and we'll get back to you within 24 hours.
//                         </p>
//                     </div>

//                     {/* Contact Grid */}
//                     <div className="grid lg:grid-cols-3 gap-8">
//                         {/* Left Column - Contact Info */}
//                         <div className="lg:col-span-1 space-y-6">
//                             {/* Quick Contact Cards */}
//                             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
//                                 <h2 className="text-lg font-semibold mb-4">Quick Contact</h2>
//                                 <div className="space-y-6">
//                                     <a href="mailto:support@socialtv.com" className="flex items-center gap-3 text-gray-600 hover:text-indigo-600 transition-colors group">
//                                         <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
//                                             <Mail className="h-5 w-5 text-indigo-600" />
//                                         </div>
//                                         <div>
//                                             <p className="text-sm text-gray-400">Email</p>
//                                             <p className="font-medium">publisher@jambojar.com</p>
//                                         </div>
//                                     </a>

//                                     <a href="tel:+18001234567" className="flex items-center gap-3 text-gray-600 hover:text-indigo-600 transition-colors group">
//                                         <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center group-hover:bg-indigo-100 transition-colors">
//                                             <Phone className="h-5 w-5 text-indigo-600" />
//                                         </div>
//                                         <div>
//                                             <p className="text-sm text-gray-400">Phone</p>
//                                             <p className="font-medium">+91 8770887988</p>
//                                         </div>
//                                     </a>

//                                     <div className="flex items-center gap-3 text-gray-600">
//                                         <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center">
//                                             <Clock className="h-5 w-5 text-indigo-600" />
//                                         </div>
//                                         <div>
//                                             <p className="text-sm text-gray-400">Business Hours</p>
//                                             <p className="font-medium">24/7 Support</p>
//                                             <p className="text-sm text-gray-500">Available from 10:00 – 19:00</p>
//                                         </div>
//                                     </div>

//                                     <div className="flex items-center gap-3 text-gray-600">
//                                         <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center">
//                                             <MapPin className="h-5 w-5 text-indigo-600" />
//                                         </div>
//                                         <div>
//                                             <p className="text-sm text-gray-400">Office</p>
//                                             <p className="font-medium">India</p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Social Links */}
//                             <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 hidden">
//                                 <h2 className="text-lg font-semibold mb-4">Follow Us</h2>
//                                 <div className="flex gap-3">
//                                     <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
//                                         <Twitter className="h-5 w-5" />
//                                     </Link>
//                                     <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
//                                         <Instagram className="h-5 w-5" />
//                                     </Link>
//                                     <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
//                                         <Linkedin className="h-5 w-5" />
//                                     </Link>
//                                     <Link to="#" className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all">
//                                         <MessageCircle className="h-5 w-5" />
//                                     </Link>
//                                 </div>
//                             </div>

//                             {/* Office Hours */}
//                             {/* <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl shadow-lg p-6 text-white">
//                             <h3 className="text-lg font-semibold mb-2">Emergency Support?</h3>
//                             <p className="text-indigo-100 text-sm mb-4">
//                                 For urgent issues outside business hours, our emergency support team is available 24/7.
//                             </p>
//                             <a
//                                 href="tel:+18001234567"
//                                 className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg hover:bg-white/30 transition-colors"
//                             >
//                                 <Phone className="h-4 w-4" />
//                                 <span>Emergency Hotline</span>
//                             </a>
//                         </div> */}
//                         </div>

//                         {/* Right Column - Contact Form */}
//                         <div className="lg:col-span-2">
//                             <div className="bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
//                                 <h2 className="text-2xl font-bold mb-6">Send us a Message</h2>

//                                 {formStatus.submitted && formStatus.success && (
//                                     <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start gap-3">
//                                         <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
//                                         <div>
//                                             <p className="text-green-800 font-medium">Message Sent!</p>
//                                             <p className="text-green-600 text-sm">{formStatus.message}</p>
//                                         </div>
//                                     </div>
//                                 )}

//                                 <form onSubmit={handleSubmit} className="space-y-6">
//                                     {/* Name and Email Row */}
//                                     <div className="grid sm:grid-cols-2 gap-4">
//                                         <div>
//                                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                                 Full Name *
//                                             </label>
//                                             <input
//                                                 type="text"
//                                                 name="name"
//                                                 value={formData.name}
//                                                 onChange={handleChange}
//                                                 required
//                                                 className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//                                                 placeholder="John Doe"
//                                             />
//                                         </div>
//                                         <div>
//                                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                                 Email Address *
//                                             </label>
//                                             <input
//                                                 type="email"
//                                                 name="email"
//                                                 value={formData.email}
//                                                 onChange={handleChange}
//                                                 required
//                                                 className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//                                                 placeholder="john@example.com"
//                                             />
//                                         </div>
//                                     </div>

//                                     {/* Subject */}
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Subject *
//                                         </label>
//                                         <input
//                                             type="text"
//                                             name="subject"
//                                             value={formData.subject}
//                                             onChange={handleChange}
//                                             required
//                                             className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//                                             placeholder="How can we help?"
//                                         />
//                                     </div>

//                                     {/* Priority */}
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Priority Level
//                                         </label>
//                                         <div className="flex gap-4">
//                                             {["low", "normal", "high", "urgent"].map((level) => (
//                                                 <label key={level} className="flex items-center gap-2">
//                                                     <input
//                                                         type="radio"
//                                                         name="priority"
//                                                         value={level}
//                                                         checked={formData.priority === level}
//                                                         onChange={handleChange}
//                                                         className="w-4 h-4 text-indigo-600"
//                                                     />
//                                                     <span className="text-sm text-gray-600 capitalize">{level}</span>
//                                                 </label>
//                                             ))}
//                                         </div>
//                                     </div>

//                                     {/* Message */}
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                                             Message *
//                                         </label>
//                                         <textarea
//                                             name="message"
//                                             value={formData.message}
//                                             onChange={handleChange}
//                                             required
//                                             rows="6"
//                                             className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none"
//                                             placeholder="Tell us more about your question or issue..."
//                                         />
//                                     </div>

//                                     {/* Submit Button */}
//                                     <button
//                                         type="submit"
//                                         disabled={isSubmitting}
//                                         className="w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition-colors font-medium flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                                     >
//                                         {isSubmitting ? (
//                                             <>
//                                                 <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                                                 <span>Sending...</span>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <Send className="h-4 w-4" />
//                                                 <span>Send Message</span>
//                                             </>
//                                         )}
//                                     </button>

//                                     <p className="text-xs text-gray-400 text-center">
//                                         By submitting this form, you agree to our privacy policy and terms of service.
//                                         We'll never share your information with third parties.
//                                     </p>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>

//                 </div>
//             </div>

//             <AuthPopup
//                 isOpen={showAuth}
//                 onClose={() => setShowAuth(false)}
//             />


//             {/* ================= FOOTER ================= */}
//             <Footer />
//         </div>
//     );
// };

// export default Contact;

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Mail,
    Phone,
    MapPin,
    MessageCircle,
    Twitter,
    Linkedin,
    Instagram,
    Send,
    CheckCircle,
    Clock,
    ArrowRight,
    Sparkles,
} from "lucide-react";

import BackToTop from "../../components/BackToTop/BackToTop";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import HeroBg from "../../../src/images/hero-bg.png";
import AuthPopup from "../../components/popup/AuthPopup";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
        priority: "normal",
    });

    const [formStatus, setFormStatus] = useState({
        submitted: false,
        success: false,
        message: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showAuth, setShowAuth] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);

        // Simulate API call
        setTimeout(() => {
            setFormStatus({
                submitted: true,
                success: true,
                message:
                    "Thank you for reaching out! Our team will get back to you within 24 hours.",
            });

            setIsSubmitting(false);

            setFormData({
                name: "",
                email: "",
                subject: "",
                message: "",
                priority: "normal",
            });
        }, 1500);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-[#FCFAF8] text-[#17191C]">

            <BackToTop />

            {/* ================= HEADER ================= */}

            <Header
                loginClick={() => {
                    setShowAuth(true);
                }}
            />

            {/* ================= HERO ================= */}

            <section className="relative overflow-hidden bg-[#FCFAF8]">
                {/* Background Image */}
                <div className="absolute inset-0 pointer-events-none">
                    <img src={HeroBg} loading="lazy" sizes="100vw" alt="" className="w-full h-full object-cover opacity-[0.28]" />
                </div>

                {/* Soft Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-[#FCFAF8]/70 to-[#FCFAF8]" />

                {/* Coral Glow */}
                <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#FF6968]/[0.07] blur-[110px]" />
                <div className="absolute top-40 -left-40 w-[400px] h-[400px] rounded-full bg-[#FFB0A9]/[0.08] blur-[110px]" />

                {/* Hero Content */}
                <div className="relative max-w-7xl mx-auto px-6">
                    <div className="min-h-[500px] flex items-center justify-center py-24">
                        <div className="max-w-4xl text-center">

                            {/* Label */}
                            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#E8E3DF] bg-white/80 backdrop-blur-md shadow-sm mb-7">
                                <MessageCircle className="w-4 h-4 text-[#FF6968]" />
                                <span className="text-sm font-semibold text-[#555B61]">
                                    Get in Touch
                                </span>
                            </div>

                            {/* Heading */}
                            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[68px] leading-[1.05] tracking-[-0.045em] font-semibold text-[#17191C] mb-7">
                                Let's{" "}
                                <span className="text-[#FF6968]">
                                    talk.
                                </span>
                            </h1>

                            {/* Description */}
                            <p className="text-base md:text-lg leading-relaxed text-[#70757B] max-w-2xl mx-auto">
                                Have a question, need support, or want to explore how SocialTV can help your business? Our team is here to help.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            {/* ================= MAIN CONTENT ================= */}

            <main className="max-w-7xl mx-auto px-6 pb-24">

                {/* Section Intro */}
                <div className="mb-10">
                    <div className="flex items-center gap-3 mb-4">
                        <span className="w-8 h-px bg-[#FF6968]" />

                        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#FF6968]">
                            Contact Us
                        </span>
                    </div>

                    <h2 className="text-3xl md:text-4xl font-semibold tracking-[-0.035em] text-[#17191C]">
                        We're here to help
                    </h2>

                    <p className="mt-3 text-[#777C81] max-w-2xl leading-relaxed">
                        Choose the easiest way to reach our team or send us a message directly.
                    </p>
                </div>


                {/* ================= CONTACT GRID ================= */}

                <div className="grid lg:grid-cols-3 gap-6">

                    {/* ================= LEFT COLUMN ================= */}

                    <div className="lg:col-span-1 space-y-5">

                        {/* Contact Information */}
                        <div className="bg-white rounded-3xl border border-[#E7E3E0] p-7 transition-all duration-300 hover:shadow-[0_20px_45px_rgba(40,30,25,0.06)]">

                            <div className="flex items-center gap-3 mb-7">
                                <div className="w-10 h-10 rounded-xl bg-[#FFF1EE] border border-[#FFD9D2] flex items-center justify-center">
                                    <MessageCircle className="w-5 h-5 text-[#FF6968]" />
                                </div>
                                <div>
                                    <h2 className="text-lg font-semibold text-[#17191C]">
                                        Quick Contact
                                    </h2>
                                    <p className="text-xs text-[#969A9E] mt-0.5">
                                        Get in touch with our team
                                    </p>
                                </div>
                            </div>


                            <div className="space-y-6">

                                {/* Email */}
                                <a href="mailto:support@klarion.media" className="flex items-center gap-4 group">
                                    <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-[#FFF8F6] border border-[#F2E5E1] flex items-center justify-center transition-all duration-300 group-hover:bg-[#FFF1EE] group-hover:border-[#FFD0C8]">
                                        <Mail className="w-5 h-5 text-[#FF6968]" />
                                    </div>
                                    <div className="min-w-0">
                                        <p className="text-xs text-[#999DA1] mb-1">
                                            Email
                                        </p>
                                        <p className="text-sm font-semibold text-[#42474C] group-hover:text-[#FF6968] transition-colors truncate">
                                            support@klarion.media
                                        </p>
                                    </div>
                                </a>

                                {/* Phone */}
                                <a href="tel:+918770887988" className="flex items-center gap-4 group">
                                    <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-[#FFF8F6] border border-[#F2E5E1] flex items-center justify-center transition-all duration-300 group-hover:bg-[#FFF1EE] group-hover:border-[#FFD0C8]">
                                        <Phone className="w-5 h-5 text-[#FF6968]" />
                                    </div>
                                    <div>
                                        <p className="text-xs text-[#999DA1] mb-1">
                                            Phone
                                        </p>
                                        <p className="text-sm font-semibold text-[#42474C] group-hover:text-[#FF6968] transition-colors">
                                            +91 8770887988
                                        </p>
                                    </div>
                                </a>

                                {/* Hours */}
                                <div className="flex items-center gap-4">
                                    <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-[#FFF8F6] border border-[#F2E5E1] flex items-center justify-center">
                                        <Clock className="w-5 h-5 text-[#FF6968]" />
                                    </div>
                                    <div>
                                        <p className="text-xs text-[#999DA1] mb-1">
                                            Business Hours
                                        </p>
                                        <p className="text-sm font-semibold text-[#42474C]">
                                            24/7 Support
                                        </p>
                                        <p className="text-xs text-[#8A8F94] mt-1">
                                            Available from 10:00 – 19:00
                                        </p>
                                    </div>
                                </div>


                                {/* Location */}
                                <div className="flex items-center gap-4">
                                    <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-[#FFF8F6] border border-[#F2E5E1] flex items-center justify-center">
                                        <MapPin className="w-5 h-5 text-[#FF6968]" />
                                    </div>
                                    <div>
                                        <p className="text-xs text-[#999DA1] mb-1">
                                            Office
                                        </p>
                                        <p className="text-sm font-semibold text-[#42474C]">
                                            India
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Support Card */}

                        <div className="relative overflow-hidden bg-[#FF6968] rounded-3xl p-7 text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_45px_rgba(255,105,104,0.20)]">
                            <div className="absolute -right-20 -top-20 w-56 h-56 rounded-full bg-white/10 blur-2xl" />
                            <div className="relative z-10">
                                <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center mb-5">
                                    <Sparkles className="w-5 h-5" />
                                </div>

                                <h3 className="text-xl font-semibold mb-2">
                                    Need quick help?
                                </h3>

                                <p className="text-sm leading-relaxed text-white/75 mb-5">
                                    Our support team typically responds within 24 hours.
                                </p>

                                <Link to="/support" className="inline-flex items-center gap-2 text-sm font-semibold text-white group">
                                    Visit Support Center

                                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                                </Link>
                            </div>
                        </div>


                        {/* Social Links */}

                        <div className="bg-white rounded-3xl border border-[#E7E3E0] p-7 hidden">

                            <h2 className="text-lg font-semibold text-[#17191C] mb-5">
                                Follow Us
                            </h2>

                            <div className="flex gap-3">
                                <Link to="#" className="w-10 h-10 rounded-xl bg-[#F7F5F3] flex items-center justify-center hover:bg-[#FFF1EE] hover:text-[#FF6968] transition-all">
                                    <Twitter className="w-5 h-5" />
                                </Link>

                                <Link to="#" className="w-10 h-10 rounded-xl bg-[#F7F5F3] flex items-center justify-center hover:bg-[#FFF1EE] hover:text-[#FF6968] transition-all">
                                    <Instagram className="w-5 h-5" />
                                </Link>

                                <Link to="#" className="w-10 h-10 rounded-xl bg-[#F7F5F3] flex items-center justify-center hover:bg-[#FFF1EE] hover:text-[#FF6968] transition-all">
                                    <Linkedin className="w-5 h-5" />
                                </Link>

                                <Link to="#" className="w-10 h-10 rounded-xl bg-[#F7F5F3] flex items-center justify-center hover:bg-[#FFF1EE] hover:text-[#FF6968] transition-all">
                                    <MessageCircle className="w-5 h-5" />
                                </Link>
                            </div>
                        </div>
                    </div>


                    {/* ================= RIGHT FORM ================= */}

                    <div className="lg:col-span-2">

                        <div className="bg-white rounded-3xl border border-[#E7E3E0] p-6 sm:p-8 md:p-10 transition-all duration-300 hover:shadow-[0_20px_55px_rgba(40,30,25,0.06)]">

                            {/* Form Header */}

                            <div className="mb-8">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="w-9 h-9 rounded-xl bg-[#FFF1EE] border border-[#FFD9D2] flex items-center justify-center">
                                        <Send className="w-4 h-4 text-[#FF6968]" />
                                    </div>
                                    <span className="text-xs uppercase tracking-[0.15em] font-semibold text-[#FF6968]">
                                        Send a Message
                                    </span>
                                </div>

                                <h2 className="text-2xl md:text-3xl font-semibold tracking-[-0.03em] text-[#17191C]">
                                    Tell us how we can help
                                </h2>

                                <p className="text-sm text-[#7B8085] mt-2">
                                    Fill out the form below and our team will get back to you as soon as possible.
                                </p>
                            </div>


                            {/* Success Message */}

                            {formStatus.submitted && formStatus.success && (
                                <div className="mb-7 p-4 rounded-2xl bg-[#F0FBF4] border border-[#CDECD8] flex items-start gap-3">

                                    <CheckCircle className="w-5 h-5 text-[#159447] flex-shrink-0 mt-0.5" />

                                    <div>
                                        <p className="text-sm font-semibold text-[#176B38]">
                                            Message Sent!
                                        </p>

                                        <p className="text-sm text-[#43845A] mt-1">
                                            {formStatus.message}
                                        </p>
                                    </div>
                                </div>
                            )}


                            {/* ================= FORM ================= */}

                            <form onSubmit={handleSubmit} className="space-y-6">

                                {/* Name / Email */}

                                <div className="grid sm:grid-cols-2 gap-5">
                                    <div>
                                        <label className="block text-sm font-semibold text-[#454A4F] mb-2">
                                            Full Name *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3.5 rounded-xl border border-[#E3DEDA] bg-[#FFFEFD] text-[#25282B] placeholder:text-[#A0A4A8] outline-none transition-all focus:border-[#FFAAA0] focus:ring-4 focus:ring-[#FF6968]/10"
                                            placeholder="John Doe"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-semibold text-[#454A4F] mb-2">
                                            Email Address *
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="w-full px-4 py-3.5 rounded-xl border border-[#E3DEDA] bg-[#FFFEFD] text-[#25282B] placeholder:text-[#A0A4A8] outline-none transition-all focus:border-[#FFAAA0] focus:ring-4 focus:ring-[#FF6968]/10"
                                            placeholder="john@example.com"
                                        />
                                    </div>
                                </div>


                                {/* Subject */}

                                <div>
                                    <label className="block text-sm font-semibold text-[#454A4F] mb-2">
                                        Subject *
                                    </label>
                                    <input
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        className="w-full px-4 py-3.5 rounded-xl border border-[#E3DEDA] bg-[#FFFEFD] text-[#25282B] placeholder:text-[#A0A4A8] outline-none transition-all focus:border-[#FFAAA0] focus:ring-4 focus:ring-[#FF6968]/10"
                                        placeholder="How can we help?"
                                    />
                                </div>


                                {/* Priority */}

                                <div>

                                    <label className="block text-sm font-semibold text-[#454A4F] mb-3">
                                        Priority Level
                                    </label>
                                    <div className="flex flex-wrap gap-2">

                                        {[
                                            "low",
                                            "normal",
                                            "high",
                                            "urgent",
                                        ].map((level) => {
                                            const active = formData.priority === level;
                                            return (
                                                <label
                                                    key={level}
                                                    className={`cursor-pointer inline-flex items-center gap-2 px-3.5 py-2 rounded-xl border text-sm font-medium capitalize transition-all ${active ? "bg-[#FFF1EE] border-[#FFB5AC] text-[#E85C4A]" : "bg-white border-[#E3DEDA] text-[#777C81] hover:border-[#FFBDB5]"}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="priority"
                                                        value={level}
                                                        checked={active}
                                                        onChange={handleChange}
                                                        className="sr-only"
                                                    />
                                                    <span
                                                        className={`w-3.5 h-3.5 rounded-full border flex items-center justify-center ${active ? "border-[#FF6968]" : "border-[#C8C5C2]"}`}
                                                    >
                                                        {active && (
                                                            <span className="w-1.5 h-1.5 rounded-full bg-[#FF6968]" />
                                                        )}
                                                    </span>
                                                    {level}
                                                </label>
                                            );
                                        })}
                                    </div>
                                </div>


                                {/* Message */}

                                <div>
                                    <label className="block text-sm font-semibold text-[#454A4F] mb-2">
                                        Message *
                                    </label>

                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="6"
                                        className="w-full px-4 py-3.5 rounded-xl border border-[#E3DEDA] bg-[#FFFEFD] text-[#25282B] placeholder:text-[#A0A4A8] outline-none transition-all resize-none focus:border-[#FFAAA0] focus:ring-4 focus:ring-[#FF6968]/10"
                                        placeholder="Tell us more about your question or issue..."
                                    />
                                </div>


                                {/* Submit */}

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="w-full py-3.5 rounded-xl bg-[#FF6968] text-white font-semibold text-sm flex items-center justify-center gap-2 transition-all duration-300 hover:bg-[#F45F5E] hover:shadow-[0_12px_28px_rgba(255,105,104,0.22)] hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0"
                                >
                                    {isSubmitting ? (
                                        <>
                                            <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />

                                            <span>
                                                Sending...
                                            </span>
                                        </>
                                    ) : (
                                        <>
                                            <Send className="w-4 h-4" />
                                            <span>
                                                Send Message
                                            </span>
                                            <ArrowRight className="w-4 h-4" />
                                        </>
                                    )}
                                </button>

                                {/* Privacy */}
                                <p className="text-xs leading-relaxed text-[#999DA1] text-center max-w-xl mx-auto">
                                    By submitting this form, you agree to our privacy policy and terms of service. We'll never share your information with third parties.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>


                {/* ================= BOTTOM NOTE ================= */}

                <div className="mt-12 text-center">
                    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white border border-[#E7E3E0]">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#4CAF72]" />
                        <span className="text-xs sm:text-sm text-[#777C81]">
                            Our team typically responds within{" "}
                            <span className="font-semibold text-[#363A3E]">
                                24 hours
                            </span>
                        </span>
                    </div>
                </div>

            </main>



            {/* ================= AUTH POPUP ================= */}

            <AuthPopup
                isOpen={showAuth}
                onClose={() => setShowAuth(false)}
            />

            {/* ================= FOOTER ================= */}

            <Footer />

        </div>
    );
};

export default Contact;